import React from 'react';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {CourseSessionCertificate} from 'src/pages/Modules/Training/shared/CourseSessionCertificate/CourseSessionCertificate';
import {TrainingDocumentTitle} from 'src/app/training/courseContentValidation';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const AdminCourseSessionCertificatePage: React.FC = () => {
  useSetDocumentTitle(TrainingDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Training}>
      <CourseSessionCertificate isAdminPath={true} />
    </ContentWrapper>
  );
};

// Register the routes with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.TrainingCourseSessionCertificate(
    ':definitionId',
    ':assignmentId',
    ':sessionId',
    ':contentId'
  ),
  element: <AdminCourseSessionCertificatePage />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.TrainingCourseSessionCertificate(
    ':definitionId',
    ':assignmentId',
    ':sessionId'
  ),
  element: <AdminCourseSessionCertificatePage />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
